import React from "react";
import Title from "../layouts/Title";
import ProjectsCard from "./ProjectsCard";

export const playlists = [
  {
    "url": "https://www.youtube.com/playlist?list=PLPfkZr8ryVZI",
    "src": "https://i.ytimg.com/vi/RQzeZhAMhmM/maxresdefault.jpg",
    "title": "SILENT HILL: Townfall"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLfKDRlJxJU3A",
    "src": "https://i.ytimg.com/vi/pzZQJqTPMRM/maxresdefault.jpg",
    "title": "marvel's wolverine"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLcb9YaHKlTmg",
    "src": "https://i.ytimg.com/vi/AUNhCGn6n-0/maxresdefault.jpg",
    "title": "ONIMUSHA: WAY OF THE SWORD"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLd6BB6ZDqe-8",
    "src": "https://i.ytimg.com/vi/ouSGfEkCRic/maxresdefault.jpg",
    "title": "A Plague Tale: Resonance"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLBIJ2W6mm6Xo",
    "src": "https://i.ytimg.com/vi/22x-hmhzX2w/maxresdefault.jpg",
    "title": "Lost Eden Season 1"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLRuMfdQJlz-Q",
    "src": "https://i.ytimg.com/vi/zInAmeI14zU/maxresdefault.jpg",
    "title": "Resident Evil 7"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLLGrQMqYCBxI",
    "src": "https://i.ytimg.com/vi/ce3Pw72xrKs/maxresdefault.jpg",
    "title": "Mortal Shell 2"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLGvzjiEWibPk",
    "src": "https://i.ytimg.com/vi/nPYRX0ibmaE/maxresdefault.jpg",
    "title": "WORLD OF TANKS"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLateH27MOM7Y",
    "src": "https://i.ytimg.com/vi/ov1zB2ZWbyI/maxresdefault.jpg",
    "title": "palworld 1.0"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLVX4_iuFvh7c",
    "src": "https://i.ytimg.com/vi/Uh267o4ID50/maxresdefault.jpg",
    "title": "Assassin's Creed Black Flag Resynced"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLPSL8aFe82gA",
    "src": "https://i.ytimg.com/vi/lUfNdpRSJ7Q/maxresdefault.jpg",
    "title": "OUTLAST"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6Jfc_Qwob1ASCWfMxcnyV7",
    "src": "https://i.ytimg.com/vi/X36l_g9KPG0/maxresdefault.jpg",
    "title": "Meccha Chameleon"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK65pVCKwyskEoEhTSy21R9g",
    "src": "https://i.ytimg.com/vi/tW44gcpWyYY/maxresdefault.jpg",
    "title": "Fears to Fathom"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7FRcKObmfmpuAOzSCW8-yk",
    "src": "https://i.ytimg.com/vi/ZytbmMK2C3s/maxresdefault.jpg",
    "title": "Poppy Playtime"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5F9nTDcsltElHixb6Z7Kn0",
    "src": "https://i.ytimg.com/vi/y3inaC0QiLY/maxresdefault.jpg",
    "title": "007 First Light"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK48R0b2Wcw0WP8cYkXG-TU6",
    "src": "https://i.ytimg.com/vi/zraw_2Uu3OQ/maxresdefault.jpg",
    "title": "Game of Thrones"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5NJufKsr6sC68sYxCyaxHr",
    "src": "https://i.ytimg.com/vi/MXrGYj9Nbes/maxresdefault.jpg",
    "title": "CRIMSON DESERT"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7maWUAHDh0TpwrumvlGWBi",
    "src": "https://i.ytimg.com/vi/Uk0weuFckVk/maxresdefault.jpg",
    "title": "UNTIL DAWN"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK68FJLDVwVtPddas0mefG1d",
    "src": "https://i.ytimg.com/vi/oFJ5Q9XQmoE/maxresdefault.jpg",
    "title": "UNCHARTED THE LOST LEGACY"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7-oEy5aKGsBnk33-eHS9Pi",
    "src": "https://i.ytimg.com/vi/_NAu5nAPYVY/maxresdefault.jpg",
    "title": "Uncharted 4"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4i51liUvnZMxsCee3ZE_gT",
    "src": "https://i.ytimg.com/vi/Gj_HOyn3_jk/maxresdefault.jpg",
    "title": "Resident Evil 9 Requiem"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK70RiSq4ftUHQFR45SvSshM",
    "src": "https://i.ytimg.com/vi/0T6ukaLePkA/maxresdefault.jpg",
    "title": "Reanimal"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7oRC9md9m_9_lXk20UCnuk",
    "src": "https://i.ytimg.com/vi/0x6TH97d4P8/maxresdefault.jpg",
    "title": "Clair Obscur: Expedition 33"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5I8_aijlcuayL4O0jN3wAK",
    "src": "https://i.ytimg.com/vi/Z4jMIb-lBpY/maxresdefault.jpg",
    "title": "Maya : Ek Pishachini"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6kwL9UOyJwEFhyvm559w6H",
    "src": "https://i.ytimg.com/vi/M8ZRaEQnNpk/maxresdefault.jpg",
    "title": "The Forsaken Hollows DLC"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4t7nTbEFq44N1C-0uQ7LZ_",
    "src": "https://i.ytimg.com/vi/_aa1aq_c6Bw/maxresdefault.jpg",
    "title": "Red Dead Redemption 2"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK43Yz6okg4K7J91-ypTDsTj",
    "src": "https://i.ytimg.com/vi/FY9aYOq87rE/maxresdefault.jpg",
    "title": "Dispatch"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6ZcY0nW3LZ5uhju1Tuv9Xx",
    "src": "https://i.ytimg.com/vi/8FRlL3bE09Q/maxresdefault.jpg",
    "title": "Dead Reset"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK53PV1KaIq4lZ3kzpzCYCzs",
    "src": "https://i.ytimg.com/vi/g7IcAebwm3E/maxresdefault.jpg",
    "title": "Little Nightmares III"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6_SFm6z16K0r_L3PDLo5X-",
    "src": "https://i.ytimg.com/vi/cgXxvtp6j_o/maxresdefault.jpg",
    "title": "Ghost of Yōtei"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5FClYhmjQ7HBrQkk7HCTGH",
    "src": "https://i.ytimg.com/vi/YwnVd3Fkp2Q/maxresdefault.jpg",
    "title": "Silent Hill f"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6JWf7TzEsSPND0MjlBjgoh",
    "src": "https://i.ytimg.com/vi/q9P8AGO_BWE/maxresdefault.jpg",
    "title": "Silksong"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6eFcftzVxjCM276a95R6Io",
    "src": "https://i.ytimg.com/vi/vYV3zjyAK7s/maxresdefault.jpg",
    "title": "A Plague Tale: Requiem"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6YVzCS0W64uDwcRktWuqid",
    "src": "https://i.ytimg.com/vi/2hwSst78FBI/maxresdefault.jpg",
    "title": "MAFIA THE OLD COUNTRY"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK77MIm1DVF2DnjN1I85Udob",
    "src": "https://i.ytimg.com/vi/4joHrTNgMBQ/maxresdefault.jpg",
    "title": "WUCHANG: Fallen Feathers"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4p9Xqx7J0dyW8nduKZCUIo",
    "src": "https://i.ytimg.com/vi/xkuV0GmDwqg/maxresdefault.jpg",
    "title": "ELDEN RING NIGHTREIGN"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7xClp5IEio19K8KH9_lG9x",
    "src": "https://i.ytimg.com/vi/Nbt9YGI0vic/maxresdefault.jpg",
    "title": "Resident Evil 4 Remake"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5GsMTNIpdEutdNviIou7z3",
    "src": "https://i.ytimg.com/vi/LSIRkOFLwrg/maxresdefault.jpg",
    "title": "The Last of Us Part II"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6dTlAYpkk5UnDg-vsgi0sD",
    "src": "https://i.ytimg.com/vi/HrENqA7LBwE/maxresdefault.jpg",
    "title": "WORLD OF WARSHIPS"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK710wnwxVHcVwAMnVtGWxQw",
    "src": "https://i.ytimg.com/vi/17vhZ_Gdf3Q/sddefault.jpg",
    "title": "Assassins Creed Shadows"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5rq2CTg0W6RDNVz4I-t82g",
    "src": "https://i.ytimg.com/vi/I6bjgSY2aLM/maxresdefault.jpg",
    "title": "Marvel's Spiderman 2"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6pu7Ljm4gDls5P3VcSm0Jh",
    "src": "https://i.ytimg.com/vi/bgMsf6DzMFo/sddefault.jpg",
    "title": "SEKIRO: SHADOWS DIE TWICE"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7auIaYf3ddVnBKWJ-HVI-4",
    "src": "https://i.ytimg.com/vi/CYSteeNfQfw/maxresdefault.jpg",
    "title": "The First Berserker Khazan"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6iRHT1AXQGZ2aTMfA_ehP4",
    "src": "https://i.ytimg.com/vi/dsG6fXIS6Ys/maxresdefault.jpg",
    "title": "Parasocial"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5pw516TPyQmgEGzz-sBya0",
    "src": "https://i.ytimg.com/vi/PqXOqIiH-KE/maxresdefault.jpg",
    "title": "Indiana Jones and the Great Circle"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6IO9ezwoEJGPpQTAp95ixF",
    "src": "https://i.ytimg.com/vi/c0QXNVq6mZE/maxresdefault.jpg",
    "title": "Dollmare"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK73Use7cr3wyCsPdFvHgyoo",
    "src": "https://i.ytimg.com/vi/R30lJck1r2M/maxresdefault.jpg",
    "title": "Squirrel with a gun"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK50AgNCj-LEOPgmwiSmr92D",
    "src": "https://i.ytimg.com/vi/nP-ZykYAAlY/maxresdefault.jpg",
    "title": "Lockdown Protocol"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4px7xwwqgjjxka21FqzUNC",
    "src": "https://i.ytimg.com/vi/soLom5ZDydg/maxresdefault.jpg",
    "title": "Silent Hill 2"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7M-4_18ORw8VEjlZ4LD3aa",
    "src": "https://i.ytimg.com/vi/TGJfHB_9Ouk/maxresdefault.jpg",
    "title": "GOD OF WAR : RAGNARÖK"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6O5xaoT8JvczlnM8iz2pjf",
    "src": "https://i.ytimg.com/vi/JY6QUQE8eyY/maxresdefault.jpg",
    "title": "Black Myth: Wukong"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4CrE0UOp2hWVfcE9vWBgwR",
    "src": "https://i.ytimg.com/vi/ZCykomhO74w/maxresdefault.jpg",
    "title": "ELDEN RING: Shadow of the Erdtree"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4Y7A1DfUn0suvcoXf_b9WP",
    "src": "https://i.ytimg.com/vi/s2rXj1ULO2s/maxresdefault.jpg",
    "title": "Kamla"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7mrgwFHwSvoeoW1LFvQAvR",
    "src": "https://i.ytimg.com/vi/kN_qpTMSbzw/maxresdefault.jpg",
    "title": "SENUA'S SAGA: HELLBLADE II"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5fEO4HTcvNxaajcjtHn_DO",
    "src": "https://i.ytimg.com/vi/FEVgWz0MthI/maxresdefault.jpg",
    "title": "Ghosts of Tsushima"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5MbAQ8mQ1bq53XB5ra9OUN",
    "src": "https://i.ytimg.com/vi/sjtVl2QVQiY/maxresdefault.jpg",
    "title": "Party Animals"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7InzsbVvzr7hJ2b211mHOc",
    "src": "https://i.ytimg.com/vi/QJioknD0318/maxresdefault.jpg",
    "title": "Tell Me Why"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5iSr7V5BB3c7qNOfri1AO4",
    "src": "https://i.ytimg.com/vi/Bjo86W36C-8/maxresdefault.jpg",
    "title": "Red Dead Redemption 2"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5EC2TYSu1UdGlCZ0b-AdYX",
    "src": "https://i.ytimg.com/vi/U2YU-QGgWFo/maxresdefault.jpg",
    "title": "Elden Ring"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7DwhMXbMHoG-XdEzTq3fEr",
    "src": "https://i.ytimg.com/vi/kRRoC2r23vk/maxresdefault.jpg",
    "title": "Palworld"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK5v-0n4arUYEbzLICNQh35f",
    "src": "https://i.ytimg.com/vi/1Hm2jsy7nOg/maxresdefault.jpg",
    "title": "Alan Wake 2"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6AsB49YJDmWRcSyWf06hof",
    "src": "https://i.ytimg.com/vi/BzEKLH3yOmo/maxresdefault.jpg",
    "title": "Detroit: Become Human"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK48GMOa3jxiszUxSshtCBBh",
    "src": "https://i.ytimg.com/vi/9PzsNlhZZZg/maxresdefault.jpg",
    "title": "30 Days Challenge"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4MbKHaoV_hFWhjMjCvLvGK",
    "src": "https://i.ytimg.com/vi/Mc627_7_wiY/maxresdefault.jpg",
    "title": "Pico Park"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK69tEYL3lBuZCchoZu7gqKI",
    "src": "https://i.ytimg.com/vi/6hQNOaqKX-M/maxresdefault.jpg",
    "title": "It Takes Two"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7ghgLBeE5wqwFmCE-PseQw",
    "src": "https://i.ytimg.com/vi/CTgklyOkbPI/maxresdefault.jpg",
    "title": "The Last Of Us"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4jCQ_VXIHBngBL4Ba_fcgg",
    "src": "https://i.ytimg.com/vi/nPBkg5-A9Eo/maxresdefault.jpg",
    "title": "Propnight"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK4sCe1nC20pWOceDY3Drt-B",
    "src": "https://i.ytimg.com/vi/F5pJaso7Rl0/maxresdefault.jpg",
    "title": "A Way Out"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6qVpWw6Jm4wAZw9MQdUTKf",
    "src": "https://i.ytimg.com/vi/AL5N6DZJnK8/maxresdefault.jpg",
    "title": "A Plague Tale: Innocence"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK7bn12YJE61ofK_RlSFR_h1",
    "src": "https://i.ytimg.com/vi/YWIdpSjk0a4/maxresdefault.jpg",
    "title": "Kena: Bridge of Spirits"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6wbQBmr3CBpn9GvP8rCb1d",
    "src": "https://i.ytimg.com/vi/TCSp7MSdGJ0/maxresdefault.jpg",
    "title": "September 7th"
  },
  {
    "url": "https://www.youtube.com/playlist?list=PLasRGNDhAMK6i07dQDzHMe_tWfoSNHTnw",
    "src": "https://i.ytimg.com/vi/E4rVsUPeVqE/maxresdefault.jpg",
    "title": "Hellblade senua's sacrifice"
  },
  {
    "url": "https://www.youtube.com/results?search_query=black+canary+cancanarycan+valorant",
    "src": "https://i.ytimg.com/vi/Pa0eA1gGZo0/hqdefault.jpg",
    "title": "Valorant"
  }
];

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="THE GAMES I HAVE PLAYED"
          des="Videos"
          title2={"(Variety Streamer for a reason)"}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        {playlists.map((item, index) => (
          <ProjectsCard title={item.title} url={item.url} src={item.src} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
